import React, { useEffect, useRef, useState } from 'react'
import DOMPurify from 'dompurify';
import { sanitizeURLs } from '../utils/helpers';
const ExpandableWYSIWYGPreview: React.FC<{ content: string }> = ({ content }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const contentRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (contentRef.current) {
            setIsOverflowing(contentRef.current.scrollHeight > 120); // same as max-height
        }
    }, []);

    return (
        <div style={{ flex: 1 }}>
            <div
                className={`content-wrapper expandable-wysiwyg-preview ${isExpanded ? 'expanded' : ''}`}
                ref={contentRef}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(sanitizeURLs(content)),
                    }}
                />
                {!isExpanded && isOverflowing && <div className="fade-overlay" />}
            </div>
            {isOverflowing && (
                <div
                    className="read-more-button"
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    {isExpanded ? 'Show less' : 'Read more'}
                </div>
            )}
        </div>
    )
}

export default ExpandableWYSIWYGPreview